import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MenuItem from "@mui/material/MenuItem";

const styles = theme => ({
  root: {
    marginTop: 30
  },
  textfield: {
  },
  leftMargin: {
    marginLeft: theme.spacing(2)
  }
});

class MultiGeotargets extends Component {

  state = {
    open: false,
    value: '',
    types: ['STATE', 'CITY', 'POSTAL_CODE', 'DMA_REGION', 'NEIGHBORHOOD', 'PROVINCE', 'TERRITORY']
  };

  handleGeoChange = (evt) => {
    this.setState({ value: evt.target.value });
  };

  addGeos = (/* evt */) => {
    const { value } = this.state;
    this.props.onAdd(value);
    this.setState({
      value: '',
      open: false
    });
  };

  toggleField = ( /* evt */) => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  render() {
    const { classes, type, onChangeType } = this.props;
    const { open, value } = this.state;
    return (
      <div className={classes.root}>
        { open ? (
          <div>
            <TextField
              multiline
              fullWidth
              value={value}
              onChange={this.handleGeoChange}
              className={classes.textfield}
              label="Enter multiple geotargets (comma separated)"
              margin="normal"
              variant="filled"
            />
            <TextField
              variant="standard"
              select
              name="geoType"
              onChange={onChangeType}
              margin="normal"
              label="Type"
              value={type}>
              {this.state.types.map(type => (
                <MenuItem key={type} value={type}>
                  {type}
                </MenuItem>
              ))}
            </TextField>
            <div align="right">
              <Button
                color="secondary"
                variant="outlined"
                onClick={this.toggleField}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                className={classes.leftMargin}
                variant="outlined"
                onClick={this.addGeos}
              >
                Add
              </Button>

            </div>
          </div>
        ) : (
          <Button
            color="primary"
            onClick={this.toggleField}
            variant="outlined"
          >
            Add Multiple
          </Button>
        ) }
      </div>
    );
  }
}

MultiGeotargets.propTypes = {
  classes: PropTypes.object.isRequired,
  onAdd: PropTypes.func.isRequired,
  onChangeType: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired
};

export default withStyles(styles)(MultiGeotargets);


